import type { FaireProductEntity } from "../../entity_types/product";

export const p_eanpefba4j: FaireProductEntity = {
  token: "p_eanpefba4j",
  type: "product",
  name: "Salt & Cracked Pepper Kettle Cooked Potato Chips",
  brandToken: "b_7czabpidt2",
  brandName: "Deep River Snacks",
  imageUrl:
    "https://cdn.faire.com/fastly/05b995a2f7c2c00334fdb4f91e5856ac824bf175fa774ff869a7f0c1bf980402.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0311404073951b0a0d43dd1cd29817e916a8e2f77e1a087e1d0a93d46ae544f2.png",
    "https://cdn.faire.com/fastly/b64c69b7ed82ffd4c7daa455e2466a60cceab40fc7f18f44a4971bc500bc2724.png",
  ],
  priceDollars: 41.56,
  description:
    "A deliciously crisp, krinkle cut potato chip with the perfect amount of salt and the lingering bite of cracked black pepper. So simple with only 4 ingredients, yet so pleasingly delicious!&nbsp;&nbsp;",
  tags: [],
  msrpDollars: 83.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:54.624Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
